


























import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import NavigationMixins from './mixins';

@Component
export default class Navigation extends mixins(Vue, NavigationMixins) {}
